import React from 'react';
import FooterTop from './FooterTop/FooterTop';

const Footer = () => {
    return (
        <div className="bg-white">
            <FooterTop></FooterTop>
        </div>
    );
};

export default Footer;
